import React from "react";
import svgPaths from "./svg-paths";
import "./styles.scss";

const SisLogo: React.FC = () => (
  <div className="sis-logo">
    <div className="sis-logo__group">
      <div className="sis-logo__shadow" />
      <div className="sis-logo__badge">
        <div className="sis-logo__sis">
          <svg fill="none" preserveAspectRatio="none" viewBox="0 0 67.7647 33.8824">
            <g>
              <path d={svgPaths.p354a2be0} fill="#FDFCFC" />
              <path d={svgPaths.p39aa0080} fill="#FDFCFC" />
              <path d={svgPaths.p174a1600} fill="#FDFCFC" />
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div className="sis-logo__text">
      <div className="sis-logo__title">
        <svg fill="none" preserveAspectRatio="none" viewBox="0 0 261.998 27.1378">
          <g>
            <path d={svgPaths.p9b419c0} fill="#0B0A0A" />
            <path d={svgPaths.p55e4770} fill="#0B0A0A" />
            <path d={svgPaths.p14994d00} fill="#0B0A0A" />
            <path d={svgPaths.p1771cd80} fill="#0B0A0A" />
            <path d={svgPaths.p1712c00} fill="#0B0A0A" />
            <path d={svgPaths.p31b7c0a0} fill="#0B0A0A" />
            <path d={svgPaths.p39044d80} fill="#0B0A0A" />
            <path d={svgPaths.p3d548200} fill="#0B0A0A" />
            <path d={svgPaths.p38b8a380} fill="#0B0A0A" />
            <path d={svgPaths.p2ec7e580} fill="#0B0A0A" />
            <path d={svgPaths.p18fe9700} fill="#0B0A0A" />
            <path d={svgPaths.p23e2a200} fill="#0B0A0A" />
            <path d={svgPaths.p2769db80} fill="#0B0A0A" />
            <path d={svgPaths.p1425180} fill="#0B0A0A" />
            <path d={svgPaths.p395a400} fill="#0B0A0A" />
            <path d={svgPaths.p3a3c0380} fill="#0B0A0A" />
            <path d={svgPaths.p202b00} fill="#0B0A0A" />
            <path d={svgPaths.p1ee80} fill="#0B0A0A" />
          </g>
        </svg>
      </div>
      <div className="sis-logo__subtitle">
        <svg fill="none" preserveAspectRatio="none" viewBox="0 0 119.147 20.952">
          <g>
            <path d={svgPaths.p3c30b780} fill="#0B0A0A" />
            <path d={svgPaths.p2054be00} fill="#0B0A0A" />
            <path d={svgPaths.p27687380} fill="#0B0A0A" />
            <path d={svgPaths.p2b7c4240} fill="#0B0A0A" />
            <path d={svgPaths.p19839bc0} fill="#0B0A0A" />
            <path d={svgPaths.p3ffc3100} fill="#0B0A0A" />
            <path d={svgPaths.pce65880} fill="#0B0A0A" />
          </g>
        </svg>
      </div>
    </div>
  </div>
);

export default SisLogo;
